module.exports = __webpack_public_path__ + "img/9788957981627.e70f0044.jpg";